module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-bg-1-f55b52087c9953ded170eeda5dfeddf1.png";